//@ts-nocheck
import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import "@banno/jha-wc/src/icons/jha-icon-delete";
import "@banno/jha-wc/src/icons/jha-icon-circle-plus";
import "@banno/jha-wc/src/icons/jha-icon-circle-checkmark-filled";
import "@banno/jha-wc/src/tables/jha-table/jha-table";
import "@banno/jha-wc/src/tables/jha-table-cell/jha-table-cell";
import "@banno/jha-wc/src/tables/jha-table-header/jha-table-header";
import "@banno/jha-wc/src/tables/jha-table-row/jha-table-row";
import "@banno/jha-wc/src/forms/jha-form-select/jha-form-select";
import "@banno/jha-wc/src/forms/jha-form-email-input/jha-form-email-input";
import "@banno/jha-wc/src/buttons/jha-button/jha-button";
import { getRequest } from "../../utils/jha-fetch";
import { Apis } from "../../utils/api-constants";
import { getRoleData } from "../../utils/getRoleData";
import formElementMixin from "@banno/jha-wc/src/js/mixins/form-element-mixin";
import Cookies from "js-cookie";
import { decryptValue, getEnvApiUrl } from "../../utils/app-utils";
@customElement("notification-view")
export class NotificationView extends formElementMixin(LitElement) {
  constructor() {
    super();
    // Initialize dropdown values with fallback data
    this.messageTypeValues = [
      { name: "Success", value: "Success" },
      { name: "Failure", value: "Failure" },
    ];
    this.notificationTypeValues = [{ name: "Email", value: "Email" }];
  }
  static readonly styles = css`
    #notDiv {
      display: flex;
      flex-direction: column;
    }
    jha-table {
      flex: 1;
    }
    jha-table-header {
      width: 20vw;
    }
    jha-form-select {
      width: 12vw;
    }
    #btnDiv {
      display: flex;
      margin-top: 20px;
      justify-content: end;
      padding-right: 15px;
      padding-left: 15px;
    }
  `;
  @property({ type: Array })
  notificationList = [];
  @property()
  toUpdate: "update";
  @property({ type: Object })
  usersData = [
    {
      number: 1,
      messageType: "",
      notificationType: "",
      to: "",
      subject: "",
      template: "",
    },
  ];

  @property({ type: Object })
  formData = {
    number: 1,
    messageType: "",
    notificationType: "",
    to: "",
    subject: "",
    template: "",
    added: false,
  };
  @property({ type: Object })
  resetformData = {
    number: 1,
    messageType: "",
    notificationType: "",
    to: "",
    subject: "",
    template: "",
    added: false,
  };
  @property({ type: Array })
  messageTypeValues = [
    { name: "Success", value: "Success" },
    { name: "Failure", value: "Failure" },
  ];
  @property({ type: Array })
  notificationTypeValues = [{ name: "Email", value: "Email" }];
  @property({ type: Boolean })
  isReadOnlyUser = /readonly/i.test(decryptValue(Cookies.get("userRole")))
  @property({ type: Boolean })
  isNotSavedNot = false;
  onAddNotClick() {
    let a = [...this.notificationList];
    a.push({
      number: a.length + 1,
      messageType: "",
      notificationType: "",
      to: "",
      subject: "",
      template: "",
      added: false,
    });
    this.notificationList = a;
    this.isNotSavedNot = true;
  }
  onSaveNotClick() {
     if (this.formDirty) {
      if (this.formValid)
        {
          this.formData.added = true;
        }
      this.notificationList.pop();
      this.formData.number = this.notificationList.length + 1;
      this.notificationList.push(JSON.parse(JSON.stringify(this.formData)));
      this.toUpdate = this.toUpdate == "" ? "update" : "";
      if (this.formValid)
      { 
        this.formData = this.resetformData;
        this.isNotSavedNot = false;
        this.dispatchEvent (new CustomEvent("onformNotValid", {detail:this.formData, bubbles:true, composed:true}));
      }
      else if (this.formDirty){
        this.dispatchEvent (new CustomEvent("onformNotValid", {detail:this.formData, bubbles:true, composed:true}));
      }
    }
  }
  onDeleteNotClick(item) {
    const deleteIndex = this.notificationList.indexOf(item);
    this.notificationList.splice(deleteIndex, 1);
    this.notificationList.forEach((element: any, index: number) => {
      element.number = index + 1;
    });
    this.toUpdate = this.toUpdate == "" ? "update" : "";
  }
  async connectedCallback() {
    super.connectedCallback();
    try {
      // getEnvApiUrl: localhost-only; .env.local never ships — no effect in prod, test, staging, or CI builds.
      const notTypeRes = await getRequest(getEnvApiUrl(Apis.NOTIFICATION_TYPE));
      const notMsgType = await getRequest(getEnvApiUrl(Apis.NOTIFICATION_MESSAGE_TYPE));
      
      // Check if we got valid data from the API
      const notificationTypes = getRoleData(notTypeRes?.list ?? []);
      const messageTypes = getRoleData(notMsgType?.list ?? []);
      
      // If we got empty arrays (due to auth errors or other issues), keep fallback values (already set as defaults)
      if (notificationTypes.length > 0 && messageTypes.length > 0) {
        // Only update if we got valid data from API
        this.notificationTypeValues = notificationTypes;
        this.messageTypeValues = messageTypes;
        this.requestUpdate();
      }
    } catch (error) {
      // Fallback values are already set as property defaults
      console.error("Failed to load notification options:", error);
    }
    await this.checkformValid();
  }
  async disconnectedCallback(): void{
    super.disconnectedCallback();
}
  async checkformValid(){
    if (this.notificationList.length > 0){
      this.formData = this.notificationList[this.notificationList.length - 1];
      if (!this.formValid)
      {
        this.isNotSavedNot = true;
      }
    }
  }
  render() {
    this.dispatchEvent(
      new CustomEvent("onNotificationChange", {
        detail: this.notificationList,
        bubbles: true,
        composed: true,
      })
      
    );
    return html`
      <div id="notDiv">
        <jha-table data=${this.notificationList}>
          <jha-table-row>
            <jha-table-header>NO.</jha-table-header>
            <jha-table-header>MESSAGE TYPE</jha-table-header>
            <jha-table-header>NOTIFICATION TYPE</jha-table-header>
            <jha-table-header>TO</jha-table-header>
            <jha-table-header>SUBJECT</jha-table-header>
            <jha-table-header>TEMPLATE</jha-table-header>
          </jha-table-row>
          ${this.notificationList?.map(
      (item) => html`
              <jha-table-row>
                <form style="display:contents;">
                  <jha-table-cell>${item.number}</jha-table-cell>
                  <jha-table-cell
                    >
                  <jha-tooltip bottom text="Select message type to send notification when workflow succeeds or fails.">
                  <jha-form-select
                      text-align="center"
                      data-auto-id="notificationMessageTypeSelect"
                      outline
                      required
                      warning="Message Type is Required"
                      .options=${this.messageTypeValues ?? []}
                      data-id="messageType"
                      @change=${this.inputValueChange}
                      @blur=${this.onSaveNotClick}
                      label="Message Type"
                      labelKey="name"
                      valueKey="value"
                      ?disabled=${item.added == true}
                      isValid
                      emptyOptionLabel="Select Message Type"
                      .value=${item.messageType}
                    ></jha-form-select
                  >
                  </jha-tooltip>
                    </jha-table-cell>
                  <jha-table-cell
                    >
                  <jha-tooltip bottom text="Select type of notification to send.">
                    <jha-form-select
                      data-auto-id="notificationTypeSelect"
                      outline
                      required
                      warning="Notification Type is Required"
                      label="Notification Type"
                      .options=${this.notificationTypeValues ?? []}
                      data-id="notificationType"
                      @change=${this.inputValueChange}
                      @blur=${this.onSaveNotClick}
                      .value=${item.notificationType}
                      labelKey="name"
                      valueKey="value"
                      ?disabled=${item.added == true}
                      isValid
                      emptyOptionLabel="Select Notification Type"
                    ></jha-form-select
                  >
                  </jha-tooltip>
                    </jha-table-cell>
                  <jha-table-cell
                    >
                  <jha-tooltip bottom text="Enter valid Email Address to receive notification.">
                    <jha-form-email-input
                      data-auto-id="notificationEmailInput"
                      required
                      warning="Email Address is Required"
                      type="email"
                      role="textbox"
                      outline
                      data-id="to"
                      placeholder="Eg: name@domain.com"
                      label="Email Address"
                      ?disabled=${item.added == true}
                      @change=${this.inputValueChange}
                      @blur=${this.onSaveNotClick}
                      .value=${item.to}
                      maxlength="256"
                    ></jha-form-email-input
                  >
                  </jha-tooltip>  
                  </jha-table-cell>
                  <jha-table-cell
                    >
                  <jha-tooltip bottom text="Enter infomation to display in subject of notification.  Allowed characters . _ - , ; @ ( )">
                    <jha-form-input
                      data-auto-id="notificationSubjectInput"
                      required
                      warning="Subject is Required"
                      type="text"
                      outline
                      data-id="subject"
                      placeholder="Enter Notification Subject"
                      label="Subject"
                      ?disabled=${item.added == true}
                      @change=${this.inputValueChange}
                      @blur=${this.onSaveNotClick}
                      maxlength="255"
                      .value=${item.subject}
                      pattern="^[A-Za-z0-9._\\-\\s\\,\\;\\@\\(\\)]+$"
                    ></jha-form-input
                  >
                  </jha-tooltip>  
                  </jha-table-cell>
                  <jha-table-cell
                    >
                  <jha-tooltip bottom text="Enter information to display in body of notificaton.  Allowed characters . _ - , ; @ ( )">
                    <jha-form-input
                      data-auto-id="notificationTemplateInput"
                      required
                      warning="Template is Required"
                      type="text"
                      placeholder="Enter Template Information"
                      outline
                      label="Template"
                      data-id="template"
                      @change=${this.inputValueChange}
                      @blur=${this.onSaveNotClick}
                      ?disabled=${item.added == true}
                      .value=${item.template}
                      maxlength="255"
                      pattern="^[A-Za-z0-9._\\-\\s\\,\\;\\@\\(\\)]+$"
                    ></jha-form-input
                  >
                  </jha-tooltip>  
                  </jha-table-cell>
                  ${item.added == true
         
          ? html`<jha-table-cell>
                          <jha-tooltip bottom text="Notification Saved">
                          <jha-button sync type="button" icon>
                            <jha-icon-circle-checkmark-filled></jha-icon-circle-checkmark-filled>
                          </jha-button>
                          </jha-tooltip>
                        </jha-table-cell>

                        <jha-table-cell>
                        <jha-tooltip left text="Click to Delete Notification">
                          <jha-button
                            data-auto-id="deleteNotificationBtn"
                            sync
                            type="button"
                            icon
                            ?disabled=${this.isReadOnlyUser}
                            @click=${() => this.onDeleteNotClick(item)}
                          >
                            <jha-icon-delete></jha-icon-delete>
                          </jha-button>
                          </jha-tooltip>
                        </jha-table-cell>`: ''}
                </form>
              </jha-table-row>
            `
    )}
        </jha-table>
        <div id="btnDiv">
        <jha-tooltip bottom text="Click to Add Notification">
          <jha-button data-auto-id="addNotificationBtn" sync outline large @click=${this.onAddNotClick} ?disabled=${this.isReadOnlyUser || this.isNotSavedNot}
            ><jha-icon-plus slot="icon-left"></jha-icon-plus>Add
            Notification</jha-button
          >
          </jha-tooltip>
        </div>
      </div>
    `;
  }
}
declare global {
  interface HTMLElementTagNameMap {
    "notification-view": NotificationView;
  }
}
